import React, { FC, useCallback, memo } from 'react';
import { useFormikContext } from 'formik';
import _forEach from 'lodash/forEach';
import { Label, FilterData, useSizesChildrenCategoryOptions, FilterDrawerType } from '@blocs.filter';
import { initialFilters, clearableChildrenSizesRangeFilters } from '../../../shared/config';
import { StyledFormikSelect } from '../../../shared/styles';

type Props = {
  type: FilterDrawerType;
} & FilterData;

const ClothingSizesChildrenCategory: FC<Props> = ({ type, name, label }) => {
  const { values, setFieldValue } = useFormikContext();

  const sizesChildrenCategoryOptions = useSizesChildrenCategoryOptions();

  const handleChange = useCallback((): void => {
    _forEach(clearableChildrenSizesRangeFilters, (filter) => {
      setFieldValue(filter, initialFilters[type][filter], false);
    });
  }, [values[name]]);

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelect
        saveAsOption
        name={name}
        size="small"
        options={sizesChildrenCategoryOptions}
        onChange={handleChange}
      />
    </>
  );
};

export default memo(ClothingSizesChildrenCategory);
